import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {jwtAuthService} from 'src/app/api/module/erp/services/auth/jwtAuthService';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {environment} from 'src/environments/environment';

declare interface RouteInfo {}
export const ROUTES: RouteInfo[] = [];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[] | undefined;
  public isCollapsed = false;
  public isShowMenu = true;
  public isShowMenuProd = true;
  rules: string = '';
  ambiente!: boolean;
  isShowMenuUser: boolean = true;
  submodulos: any;
  listaModulos = new Array<any>();

  constructor(
    private router: Router,
    private jwt: jwtAuthService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
  ) {}

  ngOnInit() {
    if (this.jwt.isUsuarioLogado()) {
      this.ambiente = environment.production;
      const currentUrl = window.location.href;
      // if (currentUrl.includes('geia.com')) {
      this.isShowMenu = false;
      //   this.isShowMenuProd = true;
      //   this.router.navigate(['/operadora/listar']);
      // }
      this.rules = this.jwt.pegarRulesDoUsuarioLogado();
      this.buscarModulosUsuarios();
    }
  }

  onClickContrato() {
    this._compartilharDadosEntreComponentsService.enviarDadosParaOutroComponent(null);
  }

  buscarModulosUsuarios() {
    let permissaoUsuario = this.jwt.sessaoService();
    const parsedPermissions = JSON.parse(permissaoUsuario.permissions);
    const modules = parsedPermissions?.modules || [];

    const modulosFiltrados = modules
      .map((modulo: any) => {
        // Filtra sub-módulos: apenas os com read = true E que não estão na lista de remoção
        const subModulesFiltrados =
          modulo.subModules
            ?.filter((sub: any) => sub.read === true && sub.active !== false && sub.Entity != null)
            //ordena em ordem alfabética
            .sort((a: any, b: any) => {
              const nomeA = a.subModuleName?.toLowerCase() || '';
              const nomeB = b.subModuleName?.toLowerCase() || '';
              return nomeA.localeCompare(nomeB);
            }) || [];

        // Retorna o módulo apenas se tiver sub-módulos com permissão de leitura
        if (subModulesFiltrados.length > 0) {
          return {
            ...modulo,
            subModules: subModulesFiltrados,
          };
        }

        return null; // Módulo sem sub-módulos com permissão
      })
      .filter((modulo: any) => modulo !== null) // Remove módulos nulos
      //ordena em ordem alfabética
      .sort((a: any, b: any) => {
        const nomeA = a.moduleName?.toLowerCase() || '';
        const nomeB = b.moduleName?.toLowerCase() || '';
        return nomeA.localeCompare(nomeB);
      });
    this.listaModulos = modulosFiltrados;
  }
}
